<template>
  <div>
    <b v-if="title">{{ title }}</b>
    <table>
      <thead>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        <tr class="row-divider">
          <td>Informado</td>
          <td class="text-right">R$ {{ valorInformadoDeclarado | formatPrice }}</td>
        </tr>
        <tr class="row-divider">
          <td>Pago</td>
          <td class="text-right success--text">R$ {{ valorPagoDeclarado | formatPrice }}</td>
        </tr>
        <tr>
          <td>Glosado</td>
          <td class="text-right red--text">R$ {{ valorGlosadoDeclarado | formatPrice }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    title: String || null,
    valorInformadoDeclarado: Number,
    valorPagoDeclarado: Number,
    valorGlosadoDeclarado: Number
  }
}
</script>

<style scoped>
p {
  margin-top: 12px;
  font-weight: 700;
}

table, td {
  border: 1px solid white;
}

table {
  font-weight: 700;
}
thead {
  background-color: #EFF3F8;
}
th {
  border: solid 1px #EFF3F8;
  padding: 2px 8px;
}
td {
  padding: 2px 8px;
}
.row-divider td, tr{
  border-bottom: 1px solid #D1DCEA;
}
</style>
